import { Options } from "react-lottie";

export const defaultOptions: Options = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  },
  animationData: undefined // This will be set in the component using this defaultProps
};
